import React from 'react';
import { Box, Link, Typography, Divider } from '@mui/material';
import CartOrDashboardButton from './CartOrDashboardButton';
import Footer from '../Shared/Footer';
import { useTranslation } from '../../hooks/useTranslation';

const DrawerContent = ({ user, toggleDrawer, theme }) => {
  const { t } = useTranslation();
  
  return (
    <div
      style={{ 
        borderTopLeftRadius: '30px',
        borderTopRightRadius: '30px',
        backgroundColor: theme.palette.common.background
      }}>
    <Box
      sx={{
        height: '70vh',
        display: 'flex',
        flexDirection: 'column',
        p: 2,
        overflow: 'auto',
        
        backgroundColor: 'none',
      }}
      role="presentation"
      onClick={() => toggleDrawer(false)}
    >
      <CartOrDashboardButton user={user} />

      <Box sx={{ border: `1px solid ${theme.palette.component.borderColor}`, borderRadius: '10px', m: 1,  backgroundColor: theme.palette.common.white, marginTop: '40px'}}>
      <Link href="/" sx={{ textDecoration: 'none' }}>
          <Typography
            align='center'
            sx={{
              p: 3,
              borderTopLeftRadius: '10px',
              borderTopRightRadius: '10px',
              color: theme.palette.common.offBlack,
              backgroundColor: theme.palette.component.componentBackground,
              ":hover": { bgcolor: theme.palette.component.componentBackground },
            }}
          >
            {t('home')}
          </Typography>
        </Link>
        <Divider />
          <Link href="/menu" sx={{ textDecoration: 'none' }}>
            <Typography
              align='center'
              sx={{
                p: 3,
                color: theme.palette.common.offBlack,
                backgroundColor: theme.palette.component.componentBackground,
                ":hover": { bgcolor: theme.palette.component.componentBackground },
              }}
            >
              {t('menu')}
            </Typography>
        </Link>
        <Divider />
        <Link href="/order" sx={{ textDecoration: 'none'}}>
          <Typography
              align='center'
              sx={{
                p: 3,
                color: theme.palette.common.offBlack,
                backgroundColor: theme.palette.component.componentBackground,
                ":hover": { bgcolor: theme.palette.component.componentBackground },
              }}
            >
            {t('order')}
          </Typography>
        </Link>
        <Divider />
        <Link href="/about" sx={{ textDecoration: 'none' }}>
          <Typography
            align='center'
            sx={{
              p: 3,
              color: theme.palette.common.offBlack,
              backgroundColor: theme.palette.component.componentBackground,
              ":hover": { bgcolor: theme.palette.component.componentBackground },
            }}
          >
            {t('about')}
          </Typography>
        </Link>
        <Divider />
        <Link href="/location" sx={{ textDecoration: 'none' }}>
          <Typography
              align='center'
              sx={{
                p: 3,
                borderBottomLeftRadius: '10px',
                borderBottomRightRadius: '10px',
                color: theme.palette.common.offBlack,
                backgroundColor: theme.palette.component.componentBackground,
                ":hover": { bgcolor: theme.palette.component.componentBackground },
              }}
            >
            {t('location')}
          </Typography>
        </Link>
      </Box>
    </Box>

    <Footer />

    </div>
  );
};

export default DrawerContent;